import React, { useEffect } from 'react';

import UrlTag from '../components/UrlTag';

import img1 from '../Images/imgPeople1.jpg';
import PeopleImg from '../Images/People.jpg';

const People = () => {
    const teamMembers = [
        {
            name: "Iftikar Hussain Choudhury",
            role: "Founder",
            image: img1
        },

    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <UrlTag />
            <div className="relative">
                <img src={PeopleImg} alt="People Img" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute inset-0 flex flex-col justify-end p-4 sm:p-8 md:p-14">
                    <div className="max-w-7xl mx-auto w-full">
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 transform translate-y-0 opacity-100 transition-all duration-500 ease-out">
                            Our Team
                        </h1>
                        <p className="text-lg sm:text-xl text-gray-200 max-w-2xl transform translate-y-0 opacity-100 transition-all duration-500 delay-100 ease-out">
                            Meet the talented individuals who make our company extraordinary
                        </p>
                    </div>
                </div>
            </div>

            {/* Team Section */}
            <div className="relative bg-white py-20 px-4">
                <div className="max-w-7xl mx-auto relative">
                    {/* Team Grid */}
                    <div className="grid items-center justify-center grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {teamMembers.map((member, index) => (
                            <div
                                key={index}
                                className="group relative overflow-hidden rounded-3xl bg-[#f3f3f3] border-slate-200 border hover:shadow-2xl transition-all duration-500 transform"
                            >
                                {/* Image Container */}
                                <div class="flex flex-col items-center space-y-4 py-8">
                                    <img alt="Portrait of a smiling man with dark hair and blue eyes wearing a purple shirt and tie on light blue background" class="w-[150px] h-[150px] rounded-full object-cover" height="150" src={member.image} width="150" />
                                    <div class="text-center">
                                        <p class="text-gray-700 text-lg font-semibold leading-tight">
                                            {member.name}
                                        </p>
                                    </div>
                                    <div class="flex items-center justify-center bg-gray-600 text-white text-sm font-medium rounded-full px-4 py-2">
                                        {member.role}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default People;